import isRegionUK from '@/utils/isRegionUK'

export const isPostcodeLookupSupported = (regionId: number) =>
  isRegionUK(regionId)
